import { Link } from 'react-router-dom';
import { categories } from '@/mocks/site';
import SectionHeading from '@/components/feature/SectionHeading';

export default function CategoryGrid() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-content px-4 md:px-6 py-14 md:py-20">
        <SectionHeading
          eyebrow="主题分类"
          title="按圈子找瓜，更快对上号"
          desc="不同圈子的爆料节奏差异很大。先挑一个圈子，再往下翻合集，能省掉大量无关信息。"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/collections?cat=${cat.id}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-50"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${cat.icon} text-2xl`}></i>
              </span>
              <span className="min-w-0">
                <span className="flex items-center gap-2">
                  <strong className="font-heading text-base font-bold text-foreground-950">
                    {cat.name}
                  </strong>
                  <span className="rounded-full bg-background-200 px-2 py-0.5 text-[11px] text-foreground-600">
                    {cat.count} 篇
                  </span>
                </span>
                <span className="mt-2 block text-sm leading-relaxed text-foreground-600">
                  {cat.desc}
                </span>
              </span>
              <i className="ri-arrow-right-up-line ml-auto mt-1 shrink-0 text-lg text-foreground-300 transition-colors group-hover:text-primary-500"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}